import React from "react";
import SVG from "react-inlinesvg";
import Modal from "react-modal";
import { t } from "ttag";

import iconXClose from "../../../../img/icons/x-close.svg";
import { focusElement } from "../../../utils/keyboardFocus";
import { EmailCaptureContent, IEmailModalSnippet } from "./EmailCaptureContent";

import styles from "./EmailModal.module.scss";

interface IProps {
    isOpen: boolean;
    onClose: (
        event: React.MouseEvent<Element> | React.KeyboardEvent<Element>,
    ) => void;
    content: IEmailModalSnippet;
}

export const EmailModal = (props: IProps): React.ReactNode => {
    const [contentHeight, setContentHeight] = React.useState<number>(360);
    const contentElemRef = React.useRef<HTMLDivElement>(null);

    const updateContentHeight = React.useCallback((height?: number): void => {
        let newHeight = 100;
        if (height) {
            newHeight = height;
        } else if (contentElemRef.current) {
            newHeight = contentElemRef.current.getBoundingClientRect().height;
        }

        setContentHeight(newHeight);
    }, []);

    const handleAfterOpen = React.useCallback(() => {
        updateContentHeight();
        focusElement(".email-modal__close");
    }, [updateContentHeight]);

    // This and the related pieces are a way to guarantee react-modal's height
    // conforms to the height of the richtext inside it.
    const style = {
        overlay: {
            backgroundColor: "rgba(0,0,0,0.2)",
        },
        content: {
            height: `${contentHeight + 2}px`,
        },
    };

    return (
        <Modal
            onAfterOpen={handleAfterOpen}
            contentLabel="Buy Direct For Exclusive Benefits"
            aria={{ modal: true }}
            isOpen={props.isOpen}
            onRequestClose={props.onClose}
            role="dialog"
            overlayClassName={"service-footer-container__react-modal-overlay"}
            className={styles.root}
            style={style}
        >
            <div>
                <button
                    className={`${styles.close} email-modal__close`}
                    onClick={props.onClose}
                    aria-label={t`close`}
                >
                    <SVG
                        aria-hidden={true}
                        className={styles.closeIcon}
                        src={iconXClose}
                        title={t`Close Icon`}
                    />
                </button>
                <div ref={contentElemRef}>
                    <EmailCaptureContent
                        content={props.content}
                        onSubmit={updateContentHeight}
                    />
                </div>
                <aside>
                    {props.content.email_snippet.image && (
                        <img src={props.content.email_snippet.image} />
                    )}
                </aside>
            </div>
        </Modal>
    );
};
